module.exports = __webpack_public_path__ + "media/images/prepaid-bundles-banner-4fcb083f407385becea48310c12d205f.png";